import { afterEvent, defineGameCard, } from '../authoring/index.js';
function grow(ctx) {
    const self = ctx.self;
    if (self === undefined)
        return;
    ctx.ops.modifyStat(self.id, 'attack', 1, self.id);
    ctx.ops.modifyStat(self.id, 'maxHealth', 1, self.id);
    ctx.ops.modifyStat(self.id, 'health', 1, self.id);
}
export const ScrapHarvesterCard = defineGameCard({
    id: 'scrap_harvester',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 1, health: 4 } },
    presentation: {
        name: 'Сборщик утиля',
        description: 'Когда создаётся ваш токен, получает +1/+1. Когда ваш токен гибнет, получает +1/+1.',
        glyph: {
            colors: ['#10213A', '#B29972', '#665757', '#4B4D59', '#883C29'],
            rows: [
                '....................',
                '....................',
                '.......111111.......',
                '......12222231......',
                '......13111141......',
                '......11222231......',
                '..141.14111141.141..',
                '.1314..111111..3141.',
                '..1411133333451141..',
                '...55514444441555...',
                '...15114334441151...',
                '......14444441......',
                '.111...111111.......',
                '15551..4....41......',
                '15151.111..111..331.',
                '.111..333..144.141..',
                '.......111.....331..',
                '......15551..4441...',
                '.......15551........',
                '........111.........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterEvent({
            abilityId: 'token_created_growth',
            event: 'TokenCreated',
            when(ctx, event) {
                return ctx.self !== undefined && event.ownerId === ctx.self.controllerId;
            },
            run: grow,
        }),
        afterEvent({
            abilityId: 'token_death_growth',
            event: 'UnitDied',
            when(ctx, event) {
                return ctx.self !== undefined && event.isToken === true
                    && (event.controllerIdAtDeath ?? event.ownerId) === ctx.self.controllerId;
            },
            run: grow,
        }),
    ],
    ui: { mechanics: ['token', 'death'] },
});
//# sourceMappingURL=scrap_harvester.js.map